import { NotificationStore } from '@/store';
/** Implements the Searcher interface for notifications to be used with InfiniteSearchScrollable.  */
export class NotificationSearcher {
    showRead;
    /**
     * Notification searcher constructor.
     *
     * @param showRead Determines whether to fetch all notifications or only unread ones.
     */
    constructor(showRead) {
        this.showRead = showRead;
    }
    /**
     * Search is not implemented for notifications, so it returns an empty result.
     *
     * @returns A promise that resolves to an empty list.
     */
    async search() {
        return { data: [], nextToken: undefined };
    }
    /**
     * Loads notifications into the store based on the pagination setting.
     *
     * @param data The pagination strategy to use ('first-page' or 'next-page').
     */
    async loadItems(
    /** Pagination data. */
    data) {
        await NotificationStore.loadNotifications({
            toLoad: data.tag,
        });
    }
    /**
     * Gets the current paginated state of notifications from the store.
     *
     * @returns The paginated loading state for notifications.
     */
    getItems() {
        return NotificationStore.getNotifications()({ unreadOnly: !this.showRead });
    }
}
